import PropTypes from 'prop-types';
import React from 'react';
import connect from './connect';
import { selectNotifications } from '../selectors/notifications';
import { removeNotification } from '../actions/notifications';
import { ICONS } from '../const';

const { SUCCESS, FAIL, CANCEL } = ICONS;
const NOTIFICATION_TIMEOUT = 5000;

const itemType = PropTypes.shape({
    dismissable: PropTypes.bool,
    icon: PropTypes.string,
    key: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
});

function Notification({ item, removeNotification }) {
    const { icon } = item;
    let dismiss = null;
    if (item.dismissable) {
        dismiss = (
            <button
                aria-label="dismiss"
                onClick={() => removeNotification(item.key)}
                className="cl-icon cl-icon-times-circle notification-close"
            />
        );
    } else {
        setTimeout(() => removeNotification(item.key), NOTIFICATION_TIMEOUT);
    }

    return (
        <div className="notification" role="alert">
            {icon === FAIL && (
                <i
                    className="cl-icon cl-icon-exclamation-triangle"
                    aria-hidden
                />
            )}
            {icon === SUCCESS && (
                <i className="cl-icon cl-icon-check-circle" aria-hidden />
            )}
            {icon === CANCEL && (
                <i className="cl-icon cl-icon-times-circle" aria-hidden />
            )}
            <div className="notification-contents">
                <div className="notification-title">{item.title}</div>
                <div>{item.text}</div>
            </div>
            {dismiss}
        </div>
    );
}
Notification.propTypes = {
    item: itemType,
    removeNotification: PropTypes.func.isRequired,
};

function Notifications({ notifications, removeNotification }) {
    return (
        <div className="notification-wrapper">
            {notifications.map(n => (
                <Notification
                    key={n.key}
                    item={n}
                    removeNotification={removeNotification}
                />
            ))}
        </div>
    );
}
Notifications.propTypes = {
    notifications: PropTypes.arrayOf(itemType),
    removeNotification: PropTypes.func.isRequired,
};

function mapStateToProps(state, props) {
    return { notifications: selectNotifications(state) };
}

export default connect(
    mapStateToProps,
    {
        removeNotification,
    }
)(Notifications);



// WEBPACK FOOTER //
// ./src/components/notifications.jsx